import { ConfigurationEditorMiniComponent } from "components/common/configuration-editor-mini";
import { loadAllChatWidgets } from "store/modules/chat-widgets/chat-widgets.helpers";
import { selectChatWidgetByConnectionId } from "store/modules/chat-widgets/chat-widgets.selectors";
import { useQueryWithStore } from "store/store.hooks";
import { OfflineHoursConfigFormInner } from "./offline-hours-config-form-inner";

export const ConfigureChatWidgetOfflineHours = ({
  connectionId,
}: {
  connectionId: string;
}) => {
  const { state: widget, retry: reload } = useQueryWithStore(
    selectChatWidgetByConnectionId(connectionId),
    loadAllChatWidgets(),
    [connectionId]
  );
  return (
    <ConfigurationEditorMiniComponent
      icon={"ri-rest-time-line"}
      title="Setup Online Hours"
      description="Let customers know when they can expect to connect with your team"
      entityId={widget?.id!}
      entityType="WIDGET"
      // onSaved={() => {
      //   reload();
      // }}
      modalWidth={900}
    >
      <OfflineHoursConfigFormInner
        basePath={["configurations", "offlineHours"]}
      />
    </ConfigurationEditorMiniComponent>
  );
};
